import React from 'react';
import Popover from '@airasia/phoenix-components/components/Popover';
import Styled from '../../utils/Styled';
import Wrapper from '../Wrapper';
import Text from '../Text/Text';
import PopoverTagPropTypes from './PopoverTag.propTypes';

const PopoverWrapper = Styled(Wrapper, {
  display: 'flex',
});

const PopoverContent = Styled(Text, {
  lineHeight: '125%',
  fontWeight: 'normal',
});

const PopoverTag = ({
  position,
  background,
  width,
  left,
  marginLeft,
  top,
  bottom,
  content,
  label,
  colorContent,
  paddingContent,
  fontSizeContent,
  right,
  rightArrow,
  theme,
}) => {
  return (
    <PopoverWrapper>
      <Popover
        accessibile
        accessible
        content={
          <PopoverContent
            color={colorContent}
            padding={paddingContent}
            fontSize={fontSizeContent}
          >
            {content}
          </PopoverContent>
        }
        position={position}
        theme={theme}
        trigger="hover"
        width={width ?? 200}
        zIndex={0}
        background={background}
        borderRadius={4}
        left={left}
        marginLeft={marginLeft}
        top={top}
        bottom={bottom}
        right={right}
        rightArrow={rightArrow}
      >
        {label}
      </Popover>
    </PopoverWrapper>
  );
};

PopoverTag.propTypes = PopoverTagPropTypes;
export default PopoverTag;
